import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaMapMarkedAlt, FaHistory, FaBullhorn, FaSearchPlus,
    FaShieldAlt, FaArrowRight, FaTimes, FaHashtag, FaStoreAlt, FaMapMarkerAlt, FaChevronLeft, FaSearch
} from "react-icons/fa";
import PublicBackMethods from "./PublicBackMethods";
import ComplaintPublicDetails from "./ComplaintPublicDetails";
import PublicComplaintsList from './PublicComplaintsList';
import ComplaintQueryModal from './Complaint/ComplaintQueryModal';

const NearbyEstablishments = () => {
    const { public_request } = PublicBackMethods();
    const navigate = useNavigate();

    const [view, setView] = useState('home');
    const [loading, setLoading] = useState(false);
    const [establishments, setEstablishments] = useState([]);
    const [searchId, setSearchId] = useState("");
    const [singleEstablishment, setSingleEstablishment] = useState(null);
    const [complaintResults, setComplaintResults] = useState(null);
    const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
    const [isIdModalOpen, setIsIdModalOpen] = useState(false);

    const handleNearbyAction = () => {
        setView('nearby');
        setLoading(true);
        setEstablishments([]);
        if (!navigator.geolocation) {
            alert("متصفحك لا يدعم تحديد الموقع");
            setLoading(false); setView('home'); return;
        }
        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const res = await public_request.post('/public/establishments/nearby', {
                        lat: pos.coords.latitude, lng: pos.coords.longitude
                    });
                    setEstablishments(res.data.establishments || []);
                } catch (e) { alert("خطأ في الاتصال بالخادم"); }
                finally { setLoading(false); }
            },
            (error) => {
                setLoading(false);
                alert("يرجى تفعيل الموقع (GPS) لعرض النتائج القريبة.");
                setView('home');
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    const handleIdSearch = async (e) => {
        if (e) e.preventDefault();
        if (!searchId) return;
        setLoading(true);
        try {
            const res = await public_request.get(`/public/establishments/${searchId}`);
            if (res.data) {
                setSingleEstablishment(res.data);
                setView('search_results');
                setIsIdModalOpen(false);
            } else {
                alert("رقم المنشأة غير موجود");
            }
        } catch (e) { alert("حدث خطأ أثناء البحث"); }
        finally { setLoading(false); }
    };

    const handleQueryComplaint = async (phone, id) => {
        setLoading(true);
        try {
            const res = await public_request.post('/public/complaints/query', {
                phoneNumber: phone, publicComplaintId: id
            });
            if (res.data) {
                setComplaintResults(res.data);
                setIsQueryModalOpen(false);
            }
        } catch (err) { alert("لا توجد بيانات لهذه الشكوى"); }
        finally { setLoading(false); }
    };

    // --- مكون كارد عرض المنشأة المطور ---
    const EstablishmentResultCard = ({ item, isSingle = false }) => (
        <div className={`${isSingle ? 'col-12 col-md-8 col-lg-6 mx-auto' : 'col-12 col-md-6 col-lg-4'} animate-fade-in`}>
            <div className={`premium-est-card ${isSingle ? 'result-focus-card' : ''}`} onClick={() => navigate(`/${item.fieldUID}`)}>
                <div className="est-card-glow"></div>

                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className={`est-icon-box ${isSingle ? 'est-icon-box-v2' : ''}`}>
                        <FaStoreAlt />
                    </div>
                    {isSingle && (
                        <div className="verification-badge">
                            <span className="pulse-dot"></span>
                            منشأة مسجلة
                        </div>
                    )}
                </div>

                <div className="text-end">
                    <h5 className={`${isSingle ? 'est-name-v2' : 'est-name'} mb-1`}>{item.name}</h5>
                    <div className="est-meta mt-2">
                        <span className="location-tag">
                            <FaMapMarkerAlt className="ms-1 text-info" />
                            {item.addressText || "العنوان غير محدد"}
                        </span>
                    </div>

                    {isSingle && <div className="card-divider"></div>}

                    <div className="est-footer mt-4 d-flex justify-content-between align-items-center">
                        <div className={`${isSingle ? 'distance-info-v2' : 'distance-badge'}`}>
                            {isSingle && <small className="text-muted d-block mb-1">تبعد عنك</small>}
                            <span>{item.distanceMeters || 0} متر</span>
                        </div>
                        <div className={`${isSingle ? 'explore-btn-v2' : 'go-btn-premium'}`}>
                            <span>{isSingle ? 'عرض التفاصيل الكاملة' : 'عرض'}</span>
                            <div className={`${isSingle ? 'icon-circle-v2' : ''}`}>
                                <FaChevronLeft style={!isSingle ? { fontSize: '10px' } : {}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="main-dashboard-wrapper" dir="rtl">
            <header className="container pt-5 text-center mb-5">
                <div className="gov-badge-premium animate-fade-in">
                    <FaShieldAlt className="ms-2 text-warning" />
                    الإدارة العامة للتجارة الداخلية وحماية المستهلك
                </div>
                <h1 className="main-title-highlight mt-3">البوابة التفاعلية</h1>

                {(view !== 'home' || complaintResults) && (
                    <button className="back-nav-btn mt-3 animate-fade-in" onClick={() => { setView('home'); setComplaintResults(null); }}>
                        <FaArrowRight className="ms-2" /> العودة للرئيسية
                    </button>
                )}
            </header>

            <div className="container px-3">
                {view === 'home' && !complaintResults && (
                    <div className="row g-2 g-md-4 justify-content-center animate-fade-in">
                        <MenuCard icon={FaMapMarkedAlt} title="المنشآت القريبة" subtitle="اكتشف المنشآت المحيطة بموقعك" gradient="linear-gradient(135deg, #0ea5e9, #2563eb)" onClick={handleNearbyAction} />
                        <MenuCard icon={FaHistory} title="متابعة شكوى" subtitle="استعلم عن حالة الشكاوي السابقة" gradient="linear-gradient(135deg, #22d3ee, #0891b2)" onClick={() => setIsQueryModalOpen(true)} />
                        <MenuCard icon={FaBullhorn} title="عينة شكاوى عامة " subtitle="استعرض الشكاوي والردود عليها" gradient="linear-gradient(135deg, #a855f7, #7e22ce)" onClick={() => setView('complaints')} />
                        <MenuCard icon={FaSearchPlus} title="بحث برقم المنشأة" subtitle="الوصول السريع لمنشأة محددة" gradient="linear-gradient(135deg, #f97316, #ea580c)" onClick={() => setIsIdModalOpen(true)} />
                    </div>
                )}

                <div className="dynamic-view-section mt-4">
                    {complaintResults ? (
                        <ComplaintPublicDetails complaint={complaintResults} onBack={() => setComplaintResults(null)} />
                    ) : (
                        <>
                            {view === 'nearby' && (
                                <div className="row g-4">
                                    {loading ? (
                                        <div className="col-12 text-center py-5">
                                            <div className="loader-orbit mb-3 mx-auto"></div>
                                            <h5 className="text-white fw-bold">جاري جلب البيانات...</h5>
                                        </div>
                                    ) : (
                                        establishments.map((item, i) => <EstablishmentResultCard key={i} item={item} />)
                                    )}
                                </div>
                            )}

                            {view === 'search_results' && singleEstablishment && (
                                <div className="row justify-content-center">
                                    <EstablishmentResultCard item={singleEstablishment} isSingle={true} />
                                </div>
                            )}

                            {view === 'complaints' && <PublicComplaintsList establishmentId={1} public_request={public_request} />}
                        </>
                    )}
                </div>
            </div>

            {/* --- مودال البحث برقم الفعالية --- */}
            {isIdModalOpen && (
                <div className="premium-modal-overlay">
                    <div className="search-modal-card animate-slide-up">
                        <div className="search-modal-header">
                            <div className="search-icon-circle">
                                <FaSearchPlus />
                            </div>
                            <button className="close-modal-btn" onClick={() => setIsIdModalOpen(false)}>
                                <FaTimes />
                            </button>
                        </div>

                        <div className="search-modal-body text-center">
                            <h4 className="fw-bold text-white mb-2">البحث السريع</h4>
                            <p className="text-muted small mb-4">أدخل الرقم التعريفي للمنشأة للحصول على التفاصيل فوراً</p>

                            <form onSubmit={handleIdSearch}>
                                <div className="search-input-wrapper mb-4">
                                    <FaHashtag className="input-field-icon" />
                                    <input
                                        type="number"
                                        className="search-main-input"
                                        placeholder="رقم المنشأة (مثال: 10245)"
                                        value={searchId}
                                        onChange={(e) => setSearchId(e.target.value)}
                                        autoFocus
                                    />
                                </div>

                                <button type="submit" className="search-submit-btn" disabled={loading}>
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                    ) : (
                                        <><FaSearch className="ms-2" /> ابدأ البحث</>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ComplaintQueryModal isOpen={isQueryModalOpen} onClose={() => setIsQueryModalOpen(false)} onQuery={handleQueryComplaint} loading={loading} />

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');
                .main-dashboard-wrapper { background: #0f172a; min-height: 100vh; font-family: 'Cairo', sans-serif; color: white; padding-bottom: 60px; overflow-x: hidden; }
                
                /* كارد المنيو الرئيسي */
                .glass-menu-card { 
                    background: white; border-radius: 28px; padding: 22px 12px; 
                    cursor: pointer; transition: 0.3s; display: flex; flex-direction: column; 
                    align-items: center; text-align: center; min-height: 175px; justify-content: center;
                }
                .glass-menu-card:hover { transform: translateY(-7px); box-shadow: 0 12px 30px rgba(0,0,0,0.4); }
                .icon-box { width: 55px; height: 55px; border-radius: 18px; display: flex; align-items: center; justify-content: center; font-size: 1.6rem; color: white; margin-bottom: 15px; }
                .card-title-text { color: #0f172a; font-size: 0.95rem; font-weight: 800; margin-bottom: 6px; }
                .card-desc-text { color: #64748b; font-size: 0.72rem; font-weight: 600; margin: 0; line-height: 1.4; max-width: 90%; }

                /* مودال البحث المحسن */
                .premium-modal-overlay { position: fixed; inset: 0; background: rgba(2, 6, 23, 0.85); backdrop-filter: blur(12px); display: flex; align-items: center; justify-content: center; z-index: 3000; padding: 20px; }
                .search-modal-card { background: #1e293b; width: 100%; max-width: 420px; border-radius: 35px; padding: 30px; border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); position: relative; }
                .search-modal-header { display: flex; justify-content: center; margin-bottom: 20px; position: relative; }
                .search-icon-circle { width: 70px; height: 70px; background: linear-gradient(135deg, #f97316, #ea580c); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; color: white; box-shadow: 0 10px 20px rgba(234, 88, 12, 0.3); }
                .close-modal-btn { position: absolute; left: 0; top: 0; background: rgba(255,255,255,0.05); border: none; color: #94a3b8; width: 35px; height: 35px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: 0.3s; }
                .close-modal-btn:hover { background: #ef4444; color: white; }
                .search-input-wrapper { background: #0f172a; border-radius: 20px; border: 2px solid #334155; padding: 5px 20px; display: flex; align-items: center; transition: 0.3s; }
                .search-input-wrapper:focus-within { border-color: #f97316; box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1); }
                .input-field-icon { color: #f97316; font-size: 1.2rem; }
                .search-main-input { background: transparent; border: none; color: white; padding: 15px; width: 100%; outline: none; font-size: 1.1rem; font-weight: 700; text-align: center; }
                .search-submit-btn { width: 100%; background: linear-gradient(135deg, #f97316, #ea580c); border: none; color: white; padding: 16px; border-radius: 20px; font-weight: 800; font-size: 1.1rem; transition: 0.3s; display: flex; align-items: center; justify-content: center; }
                .search-submit-btn:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(234, 88, 12, 0.4); opacity: 0.95; }

                /* كارد المنشأة المطور للنتائج */
                .premium-est-card { background: rgba(30, 41, 59, 0.5); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 30px; padding: 25px; position: relative; overflow: hidden; cursor: pointer; transition: all 0.4s; }
                .premium-est-card:hover { transform: translateY(-5px); border-color: #38bdf8; }
                
                .result-focus-card { background: linear-gradient(145deg, #1e293b, #0f172a) !important; border: 1px solid rgba(56, 189, 248, 0.4) !important; padding: 35px !important; border-radius: 40px !important; }
                
                .est-icon-box { width: 50px; height: 50px; background: linear-gradient(135deg, #38bdf8, #2563eb); border-radius: 15px; display: flex; align-items: center; justify-content: center; color: white; font-size: 1.4rem; }
                .est-icon-box-v2 { width: 65px; height: 65px; border-radius: 20px; font-size: 1.8rem; }
                
                .est-name { font-weight: 800; color: #f8fafc; font-size: 1.1rem; }
                .est-name-v2 { font-size: 1.5rem; font-weight: 900; color: white; }
                
                .verification-badge { background: rgba(16, 185, 129, 0.1); color: #10b981; padding: 6px 14px; border-radius: 100px; font-size: 0.75rem; font-weight: 700; border: 1px solid rgba(16, 185, 129, 0.2); display: flex; align-items: center; }
                .pulse-dot { width: 8px; height: 8px; background: #10b981; border-radius: 50%; margin-left: 8px; animation: pulse 2s infinite; }
                
                .card-divider { height: 1px; background: linear-gradient(to left, rgba(255,255,255,0.1), transparent); margin: 20px 0; }
                
                .distance-badge { background: rgba(15, 23, 42, 0.6); border: 1px solid rgba(56, 189, 248, 0.2); color: #38bdf8; padding: 5px 12px; border-radius: 100px; font-size: 0.75rem; font-weight: 700; }
                .distance-value { color: #38bdf8; font-weight: 800; font-size: 1.1rem; }
                
                .explore-btn-v2 { display: flex; align-items: center; gap: 10px; color: #38bdf8; font-weight: 700; font-size: 0.9rem; }
                .icon-circle-v2 { width: 32px; height: 32px; background: rgba(56, 189, 248, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: 0.3s; }
                .result-focus-card:hover .icon-circle-v2 { background: #38bdf8; color: #0f172a; transform: translateX(-5px); }

                .gov-badge-premium { display: inline-flex; align-items: center; background: rgba(56, 189, 248, 0.1); border: 1px solid rgba(56, 189, 248, 0.2); padding: 8px 18px; border-radius: 100px; color: #38bdf8; font-size: 0.85rem; font-weight: 700; }
                .main-title-highlight { font-size: 2.1rem; font-weight: 900; background: linear-gradient(to bottom, #fff, #94a3b8); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                
                .back-nav-btn { background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: white; padding: 8px 20px; border-radius: 12px; transition: 0.3s; }
                .back-nav-btn:hover { background: white; color: #0f172a; }

                @keyframes pulse { 0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); } 70% { box-shadow: 0 0 0 10px rgba(16, 185, 129, 0); } 100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); } }
                @keyframes spin { to { transform: rotate(360deg); } }
                .loader-orbit { width: 45px; height: 45px; border: 3px solid rgba(56, 189, 248, 0.1); border-top-color: #38bdf8; border-radius: 50%; animation: spin 1s linear infinite; }

                @media (max-width: 576px) {
                    .main-title-highlight { font-size: 1.7rem; }
                    .result-focus-card { padding: 25px !important; }
                    .est-name-v2 { font-size: 1.2rem; }
                }
            `}</style>
        </div>
    );
};

const MenuCard = ({ icon: Icon, title, subtitle, gradient, onClick }) => (
    <div className="col-6 col-md-3">
        <div className="glass-menu-card" onClick={onClick}>
            <div className="icon-box" style={{ background: gradient }}><Icon /></div>
            <h3 className="card-title-text">{title}</h3>
            <p className="card-desc-text">{subtitle}</p>
        </div>
    </div>
);

export default NearbyEstablishments;